var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.293 6.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 12 9.293 7.707a1 1 0 010-1.414z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjI5Mjg5IDYuMjkyODlDOS42ODM0MiA1LjkwMjM3IDEwLjMxNjYgNS45MDIzNyAxMC43MDcxIDYuMjkyODlMMTUuNzA3MSAxMS4yOTI5QzE2LjA5NzYgMTEuNjgzNCAxNi4wOTc2IDEyLjMxNjYgMTUuNzA3MSAxMi43MDcxTDEwLjcwNzEgMTcuNzA3MUMxMC4zMTY2IDE4LjA5NzYgOS42ODM0MiAxOC4wOTc2IDkuMjkyODkgMTcuNzA3MUM4LjkwMjM3IDE3LjMxNjYgOC45MDIzNyAxNi42ODM0IDkuMjkyODkgMTYuMjkyOUwxMy41ODU4IDEyTDkuMjkyODkgNy43MDcxMUM4LjkwMjM3IDcuMzE2NTggOC45MDIzNyA2LjY4MzQyIDkuMjkyODkgNi4yOTI4OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };